import React from 'react';

import {Icon} from '@albert-io/atomic';
import {getOrigin, getMandarkURL} from '@albert-io/environment';

import SocialButton from '../SocialButton';

interface Props {
  disabled?: boolean;
}

export default function GoogleButton({disabled = false}: Props) {
  return (
    <SocialButton
      provider='google'
      href={getMandarkURL(`/auth/google?redirect_host=${getOrigin()}`)}
      disabled={disabled}
    >
      <Icon icon={['fab', 'google']} />
      &nbsp; Log in with Google
    </SocialButton>
  );
}
